import React from 'react';
import './home-styles/home-section4.scss';


const HomeSection4 = () =>{
    return(
        <div className='home-section4'>
            <div className='section light-section'>
            <div className='heading-section'>
                    <h3>CAREER OPPORTUNITIES</h3>
                </div>

                <div className='row'>
                    <div className='heading-content'>
                    <p>Once you complete the Gold Appraisal Training Program, we provide career guidance and business support to help you start your journey 
                        in the gold valuation industry.
                    </p>
                    </div>

                </div>
                <div className='row job-opportunities'>
                    <div className='row job-opportunities-heading'>
                        <h4>Job Opportunities</h4>
                    </div>
                    <div className='row job-oppurtunities-content'>
                        <div className='job-opportunities-sub-heading'><p> We guide you on where jobs are available :</p></div>
                        <div className='row job-list-section d-flex justify-content-center'>

                            <ul className='job-list'>
                            <li>Any nationalize bank (Eg . SBI, Indian overseas Bank).</li>
                            <li>Any Gold Finance (Eg. Muthoot, Shriramm etc..).</li>
                            <li>Jewellery shop role of Appraiser.</li>
                            <li>Pawn Shops.</li>
                        </ul>
                        </div>
                    
                    </div>
                </div>

                <div className='row business'>
                    <div className='row business-heading'>
                     <h4>
                     Business Support
                     </h4>
                    </div>

                    <div className='row business-content '>
                        <ul>
                            <li>We provide insights on how to start your own gold appraisal shop.</li>
                            <li> Learn the legal procedures, investment requirements, and market strategies.</li>
                            <li>Get a step-by-step guide on setting up a successful gold appraisal business.</li>
                        </ul>

                    </div>


                </div>

            </div>
        </div>
    )
}

export default HomeSection4